import React, { useId, useState } from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';

import css from './SellerPrivateNoteMaybe.module.css';

/**
 * Read-only seller-only private note.
 * Renders nothing when note is empty/missing.
 *
 * @component
 * @param {Object} props
 * @param {string|null|undefined} props.note - Note text (already trimmed)
 * @param {'disclosure'|'badgeExpand'} [props.variant='disclosure']
 * @param {string} [props.className]
 * @param {string} [props.rootClassName]
 * @returns {JSX.Element|null}
 */
const SellerPrivateNoteMaybe = props => {
  const { note, variant = 'disclosure', className, rootClassName } = props;
  const [expanded, setExpanded] = useState(false);
  const panelId = useId();

  if (!note || typeof note !== 'string') {
    return null;
  }

  const classes = classNames(rootClassName || css.root, className, {
    [css.badgeExpand]: variant === 'badgeExpand',
  });

  if (variant === 'badgeExpand') {
    return (
      <div className={classes}>
        <button
          type="button"
          className={classNames(css.badgeButton, { [css.badgeButtonExpanded]: expanded })}
          aria-expanded={expanded}
          aria-controls={panelId}
          onClick={() => setExpanded(open => !open)}
        >
          <span className={css.badgeIcon} aria-hidden="true">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.5 1.75h5.25L12.25 5.25v7a.75.75 0 01-.75.75h-8a.75.75 0 01-.75-.75v-9.5a.75.75 0 01.75-.75z"
                stroke="currentColor"
                strokeWidth="1.25"
                strokeLinejoin="round"
              />
              <path
                d="M8.75 1.75V5.25H12.25"
                stroke="currentColor"
                strokeWidth="1.25"
                strokeLinejoin="round"
              />
              <path
                d="M4.5 8h5M4.5 10.25h3.5"
                stroke="currentColor"
                strokeWidth="1.25"
                strokeLinecap="round"
              />
            </svg>
          </span>
          <FormattedMessage id="SellerPrivateNoteMaybe.badgeLabel" />
        </button>
        {expanded ? (
          <div id={panelId} className={css.expandedPanel}>
            <p className={css.noteText}>{note}</p>
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <details className={classes}>
      <summary className={css.summary}>
        <FormattedMessage id="SellerPrivateNoteMaybe.disclosureLabel" />
      </summary>
      <div className={css.disclosureBody}>
        <p className={css.noteText}>{note}</p>
      </div>
    </details>
  );
};

export default SellerPrivateNoteMaybe;
